import React, { useEffect, useState } from 'react';
import {
  Button,
  Container,
  Divider,
  Grid,
  IconButton,
  TextField,
  Typography,
  Stack,
  CircularProgress,
} from '@mui/material';
import { environment } from '../../../environments/environment';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import PlusOneIcon from '@mui/icons-material/PlusOne';
import GoogleMapReact from 'google-map-react';
import GoogleMap from './googlemaps';
import MailIcon from '@mui/icons-material/Mail';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import '../Menu/index.css';
import footer from '../../../assets/contactus.png';
import { Box } from '@mui/system';
import { Field, Formik } from 'formik';
import * as yup from 'yup';
import { firestore } from '../../../../../../libs/firebase-service/src';
import CustomPhoneNumber from '../../components/PhoneNumber/PhoneInput';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { fetchData, handleToaster } from '../../Utils/UtilsFunctions';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import { Helmet } from 'react-helmet';
import PhoneInternational from '../../components/PhoneNumber/phoneinternational';
import { startsWithPlus } from '../CheckoutPage/utils';
import SectionHeader from '../../components/common/SectionHeader';
import { useNearestStore } from '../../hooks/useNearestStore';
import { useUserLocation } from '../../hooks/useUserLocation';
// Note: only Facebook and Instagram are shown per request
function Contactus() {
  const [loading, setLoading] = useState(false);
  const [emailErr, setEmailErr] = useState('');
  const [formikRef, setFormikRef] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState('');
  const stores = useSelector((state) => state.shopReducer.stores);
  const [t, i18n] = useTranslation();

  const [time24, setTime24] = useState('');
  const [time24close, setTime24close] = useState('');

  const [time12open, setTime12open] = useState('');
  const [time12close, setTime12close] = useState('');
  const pattern = /^[a-zA-Z0-9]+@[a-zA-Z0-9.]+$/;

  useEffect(() => {
    setTime12open(convertTo12Hour(time24));
    setTime12close(convertTo12Hourclose(time24close));
  }, []);

  // Sync phoneNumber state into Formik when it changes
  // Only update the value here; we let onBlur control when the field is marked as touched
  useEffect(() => {
    if (formikRef && phoneNumber !== undefined) {
      formikRef.setFieldValue('phoneNumber', phoneNumber);
    }
  }, [phoneNumber, formikRef]);
  // Location hook
  const {
    userLocation,
    isGettingLocation,
    locationError,
    getLocationWithFallbacks,
    setLocationFromAddress,
  } = useUserLocation({
    autoStart: true,
    enableConsoleLogging: true,
  });
  // Nearest store hook
  const {
    nearestStore,
    selectedStore,
    isLoadingStores,
    storeError,
    selectStore,
    refreshStores,
    getStoresByDistance,
  } = useNearestStore({
    userLocation,
    autoSelectNearest: true,
    enableConsoleLogging: true,
  });
  const convertTo12Hour = (time24) => {
    if (typeof time24 !== 'string' || !time24.includes(':')) {
      return '';
    }
    const [hours, minutes] = time24.split(':');
    let suffix = 'AM';
    let hours12 = parseInt(hours, 10);

    if (hours12 >= 12) {
      suffix = 'PM';
      if (hours12 > 12) {
        hours12 -= 12;
      }
    }

    return `${hours12}:${minutes} ${suffix}`;
  };
  const convertTo12Hourclose = (time24close) => {
    if (typeof time24close !== 'string' || !time24close.includes(':')) {
      return '';
    }
    const [hours, minutes] = time24close.split(':');
    let suffix = 'AM';
    let hours12 = parseInt(hours, 10);

    if (hours12 >= 12) {
      suffix = 'PM';
      if (hours12 > 12) {
        hours12 -= 12;
      }
    }

    return `${hours12}:${minutes}${suffix}`;
  };

  useEffect(() => {
    if (stores[0] && Array.isArray(stores[0].timing)) {
      stores[0].timing.forEach((c) => {
        if (Array.isArray(c.slots)) {
          c.slots.forEach((b) => {
            setTime24(b.open_time);
            setTime24close(b?.close_time);
          });
        }
      });
    }
  }, [stores]);
  const handleSubmit = async (values) => {
    setLoading(true);
    const updateDoc = await firestore.collection('restaurant').doc();
    const doc = await firestore.collection('contactus').doc();
    let phoneNumbert = values.phoneNumber;

    const re = /\S+@\S+\.\S+/;

    try {
      if (doc?.id.length > 0 && re.test(values?.email)) {
        setEmailErr('');
        
        // Save contact form data
        await firestore
          .collection('contactus')
          .doc(doc?.id)
          .set({
            firstName: values.firstName,
            lastName: values.lastName,
            email: values.email,
            phoneNumber: phoneNumbert,
            message: values.message,
            id: doc.id,
            createdAt: new Date(),
          });

        // Update restaurant document
        await firestore
          .collection('restaurant')
          .doc('Restaurant')
          .set(
            {
              update_items_id: updateDoc.id,
            },
            { merge: true }
          );

        // Send email and show toast
        await fetchData(
          `${environment?.apiUrl}/sendEmail?restaurantId=${environment.restaurantId}`,
          'post',
          {
            type: 'contactus',
            id: doc.id,
          }
        )
          .then((c) => {
            handleToaster('success', t('contactUs.sentSuccessfully'));
          })
          .catch((e) => {
            handleToaster('error', e);
          });

        // Reset form after successful submission
        values.firstName = '';
        values.lastName = '';
        values.email = '';
        values.message = '';
        values.phoneNumber = '';

        setPhoneNumber('');

        if (formikRef && typeof formikRef.resetForm === 'function') {
          formikRef.resetForm();
        } else if (
          formikRef &&
          typeof formikRef.setFieldValue === 'function'
        ) {
          formikRef.setFieldValue('phoneNumber', '');
        }
      } else {
        if (!re.test(values?.email)) {
          setEmailErr(`${t('contactUs.validName')}`);
        }
      }
    } catch (e) {
      console.log('err:', e);
      handleToaster('error', t('errorTryAgain'));
    } finally {
      setLoading(false);
    }
  };

  const validationScheme = yup.object().shape({
    firstName: yup
      .string()
      .trim()
      .matches(
        /^[A-Za-z\s]+$/,
        t('careerss.nameShouldContainOnlyLettersAndSpaces')
      )
      .min(3, t('careerss.minCharMustEqual3'))
      .max(30, t('careerss.maxCharMustEqual30'))
      .required(`${t('contactUs.firstNameErr')}`),
    lastName: yup
      .string()
      .matches(
        /^[a-zA-Z]+(?: [a-zA-Z]+)*$/,
        t(
          'contactUs.shouldnotContainNumbersSpecialcharactersOrSpacesAtBeginningOrEnd'
        )
      )
      .min(3, t('careerss.minCharMustEqual3'))
      .max(30, t('careerss.maxCharMustEqual30'))
      .required(`${t('contactUs.lastNaneErr')}`),
    message: yup
      .string()
      .matches(/^(?!\s*$).*/, t('careerss.shouldnotContainOnlySpaces'))
      .min(3, t('careerss.minCharMustEqual3'))
      .max(250, t('careerss.maxCharMustEqual250'))
      .required(`${t('contactUs.messageErr')}`),

    email: yup
      .string()
      .required(`${t('contactUs.emailErr')}`)
      .email(t('careerss.pleaseProvideValidEmail')),

    phoneNumber: yup
      .string()
      .required(`${t('careerss.phoneErr')}`)
      .test('is-plus-one', `${t('validNumber')}`, function (value) {
        if (value && value.startsWith('+1')) {
          return startsWithPlus(value, '+1');
        }
        if (value && value.startsWith('+962')) {
          return startsWithPlus(value, '+962');
        }
        return true;
      }),
  });

  return (
    <>
      {environment?.restaurantId === 'istanbulDk' ||
        (environment.restaurantId === 'taqwasbakery' && (
          <Helmet>
            <title>Taqwa's Bakery and Restaurant | Contact us</title>
          </Helmet>
        ))}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      {/*  */}
      {/* {environment.restaurantId === 'ttJordan' && (
        <>
          <img
            alt="tesxt"
            height="90%"
            src={footer} // use normal <img> attributes as props
            width="100%"
          />
          <Container maxWidth={'lg'} style={{ marginTop: '20px' }}>
            <Grid
              container
              spacing={2}
              columns={18}
              style={{
                display: 'flex',
                justifyContent: 'center',
                textAlign: 'center',
                marginTop: '30px',
                marginBottom: '30px',
              }}
            >
              <Grid item lg={6} xs={12}>
                <Typography
                  variant="h3"
                  style={{
                    color: environment.mainColor,
                    fontFamily: `Hanalei Fill, cursive`,
                  }}
                >
                  {t('contactUs.workingHours')}
                </Typography>

                <br></br>
                <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                  {t('contactUs.Daily')}{' '}
                </Typography>

                {stores[0]?.timing.map((c,index) => (
                  <Typography
                  key={index}
                    variant="body1"
                    style={{ color: 'gray', fontWeight: 'normal' }}
                  >
                    {c.slots.map((slot, slotIndex) => {
                      // Combine seconds and nanoseconds to get the timestamp in milliseconds
                      const timestamp =
                        slot.open_time.seconds * 1000 +
                        slot.open_time.nanoseconds / 1e6;
                      const openTime = new Date(timestamp);
                      const timestampclose =
                        slot.close_time.seconds * 1000 +
                        slot.close_time.nanoseconds / 1e6;
                      const close_time = new Date(timestampclose);

                      return (
                        <div key={slotIndex}>
                          {c.day}
                          {''}: {moment(openTime).format(' h:mm A')} -{' '}
                          {moment(close_time).format(' h:mm A')}
                        </div>
                      );
                    })}
                  </Typography>
                ))}
              </Grid>
              <Grid item lg={6} xs={12}>
                <Typography
                  variant="h3"
                  style={{
                    color: environment.mainColor,
                    fontFamily: `Hanalei Fill, cursive`,
                  }}
                >
                  {t('contactUs.ContactInfo')}{' '}
                </Typography>
                <br></br>
                <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                  {t('contactUs.ourPhone')}{' '}
                </Typography>
                <Typography
                  variant="body1"
                  style={{
                    color: 'gray',
                    fontWeight: 'normal',
                    direction: 'initial',
                  }}
                >
                  <a
                    href={`tel:${environment.phoneNumber}`}
                    style={{
                      cursor: 'pointer',
                    }}
                  >
                    {environment.phoneNumber}
                  </a>
                </Typography>
                <br />
                <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                  {t('contactUs.ourLocation')}{' '}
                </Typography>
                <Typography
                  variant="body1"
                  style={{ color: 'gray', fontWeight: 'normal' }}
                >
                  <a
                    href={
                      environment?.restaurantId === 'ttJordanDev'
                        ? 'https://www.google.com/maps/place/Taqwas+Bakery+and+Restaurant/@42.960375,-87.949907,1748m/data=!3m1!1e3!4m15!1m8!3m7!1s0x880511411c31a553:0x77dc00e4b73e5783!2sTaqwas+Bakery+and+Restaurant!8m2!3d42.9603751!4d-87.9499074!10e1!16s%2Fg%2F11jrkzlvs2!3m5!1s0x880511411c31a553:0x77dc00e4b73e5783!8m2!3d42.9603751!4d-87.9499074!16s%2Fg%2F11jrkzlvs2?hl=en'
                       : environment?.restaurantId === 'ttJordan'
                        ? 'https://www.google.com/maps/place/Taqwas+Bakery+and+Restaurant/@42.960375,-87.949907,1748m/data=!3m1!1e3!4m15!1m8!3m7!1s0x880511411c31a553:0x77dc00e4b73e5783!2sTaqwas+Bakery+and+Restaurant!8m2!3d42.9603751!4d-87.9499074!10e1!16s%2Fg%2F11jrkzlvs2!3m5!1s0x880511411c31a553:0x77dc00e4b73e5783!8m2!3d42.9603751!4d-87.9499074!16s%2Fg%2F11jrkzlvs2?hl=en'
                        : environment?.restaurantId === 'istanbulDk'
                        ? 'https://www.google.com/maps/place/Taqwas+Bakery+and+Restaurant/@42.960375,-87.949907,1748m/data=!3m1!1e3!4m15!1m8!3m7!1s0x880511411c31a553:0x77dc00e4b73e5783!2sTaqwas+Bakery+and+Restaurant!8m2!3d42.9603751!4d-87.9499074!10e1!16s%2Fg%2F11jrkzlvs2!3m5!1s0x880511411c31a553:0x77dc00e4b73e5783!8m2!3d42.9603751!4d-87.9499074!16s%2Fg%2F11jrkzlvs2?hl=en'
                        : environment?.restaurantId === 'alyousef'
                        ? 'https://www.google.com/maps/place/Al-Yousef+Supermarket+%26+Restaurant/@42.9295555,-87.9399237,17z/data=!3m1!4b1!4m6!3m5!1s0x88051151327e486b:0x7c529f0a50e1089d!8m2!3d42.9295555!4d-87.9399237!16s%2Fg%2F11bw50pjkw?entry=ttu'
                        : 'https://www.google.com/maps/place/700+W+Wisconsin+Ave+%23A,+Milwaukee,+WI+53233,+EUA/@43.0389455,-87.9205169,17z/data=!3m1!4b1!4m6!3m5!1s0x8805199d8fc34fc9:0x19a0735cad76b699!8m2!3d43.0389455!4d-87.9205169!16s%2Fg%2F11qzdbhjb8'
                    }
                    target="_blank"
                  >
                    {environment.address}
                  </a>
                </Typography>
              </Grid>{' '}
              <Grid item lg={6} xs={12}>
                <Typography
                  variant="h3"
                  style={{
                    color: environment.mainColor,
                    fontFamily: `Hanalei Fill, cursive`,
                  }}
                >
                  {t('contactUs.stayInTouch')}
                </Typography>
                <br />
                <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                  {t('contactUs.SocialLinks')}{' '}
                </Typography>
                <Grid
                  container
                  direction="row"
                  style={{ display: 'flex', justifyContent: 'center' }}
                >
                  {environment.facebookLink !== '' && (
                    <Grid item lg={1}>
                      <a href={environment.facebookLink} target="_blank" rel="noreferrer">
                        <FacebookIcon style={{ color: 'gray' }} />
                      </a>
                    </Grid>
                  )}
                  {environment.instagramLink !== '' && (
                    <Grid item lg={1}>
                      <a href={environment.instagramLink} target="_blank" rel="noreferrer">
                        <InstagramIcon style={{ color: 'gray' }} />
                      </a>
                    </Grid>
                  )}
                </Grid>
                <br />
                <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                  {t('contactUs.emailAndSupport')}
                </Typography>
                <Typography
                  variant="body1"
                  style={{ color: 'gray', fontWeight: 'normal' }}
                >
                  <a
                    href={`mailto:${environment.email}`}
                    style={{ cursor: 'pointer', marginLeft: '5px' }}
                  >
                    {environment.email}
                  </a>
                </Typography>
              </Grid>
            </Grid>

            <Grid item container justify="center" xs={12}>
              <div style={{ height: '80vh', width: '100%' }}>
                <GoogleMap />
              </div>
            </Grid>
          </Container>
        </>
      )} */}
      <Box position={'relative'}>
        {(environment?.restaurantId === 'fattyPattyDev' ||
          environment?.restaurantId === 'fattyPatty') && (
          <SectionHeader
            title="Contact Us"
            breadcrumbs={[
              { label: 'Home', path: '/' },
              { label: 'Contact Us', current: true },
            ]}
            fontFamily="Jost"
            showBreadcrumbs={true}
            titleVariant="h2"
            customStyles={{
              title: { fontSize: '40px', fontWeight: '700' },
              container: { minHeight: '250px' },
            }}
          />
        )}

        <Grid
          container
          spacing={4}
          width={{ xs: '95%', sm: '90%', md: '85%' }}
          sx={{
            margin: '0 auto',
            boxShadow: '0px 0px 50px 0px #45454526',
            borderRadius: '16px',
            padding: { xs: '16px', sm: '20px', md: '32px' },
            my: 5,
            position: 'relative',
            mt: { xs: '-30px', md: '-50px' },
            zIndex: 7,
            backgroundColor: 'white',
          }}
        >
          <Grid item xs={12} md={6}>
            <Container maxWidth={'md'} sx={{ pl: { xs: 0, md: 2 } }}>
              <Formik
                initialValues={{
                  firstName: '',
                  lastName: '',
                  phoneNumber: '',
                  message: '',
                  email: '',
                }}
                onSubmit={handleSubmit}
                validationSchema={validationScheme}
              >
                {(formikProps) => {
                  const {
                    handleBlur,
                    handleChange,
                    values,
                    errors,
                    handleSubmit,
                    touched,
                    setFieldValue,
                  } = formikProps;
                  // set formikRef for external sync
                  if (!formikRef) setFormikRef(formikProps);

                  return (
                    <div>
                      {environment?.restaurantId !== 'fattyPattyDev' &&
                        environment?.restaurantId !== 'fattyPatty' && (
                          <Divider />
                        )}

                      <Grid
                        item
                        md={12}
                        xs={12}
                        style={{ display: 'flex', justifyContent: 'center' }}
                      ></Grid>
                      <br />
                      <Grid item md={12} xs={12}>
                        <Typography
                          variant="h4"
                          style={{ color: 'black', fontWeight: 'bold' }}
                          sx={{
                            color: '#172B4D',
                            fontWeight: '700',
                            fontSize: '40px',
                            fontFamily: 'Jost , sans-serif',
                            textTransform: 'capitalize ',
                          }}
                        >
                          Get In Touch With us
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 2, my: 2 }}>
                          {environment.facebookLink !== '' && (
                            <a
                              href={environment.facebookLink}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <Stack
                                alignItems={'center'}
                                justifyContent={'center'}
                                sx={{
                                  cursor: 'pointer',
                                  borderRadius: '50%',
                                  backgroundColor: environment.mainColor,
                                  width: '40px',
                                  height: '40px',
                                }}
                              >
                                <FacebookIcon
                                  sx={{ color: 'white', fontSize: '14px' }}
                                />
                              </Stack>
                            </a>
                          )}
                          {environment.instagramLink !== '' && (
                            <a
                              href={environment.instagramLink}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <Stack
                                alignItems={'center'}
                                justifyContent={'center'}
                                sx={{
                                  cursor: 'pointer',
                                  borderRadius: '50%',
                                  backgroundColor: environment.mainColor,
                                  width: '40px',
                                  height: '40px',
                                }}
                              >
                                <InstagramIcon
                                  sx={{ color: 'white', fontSize: '14px' }}
                                />
                              </Stack>
                            </a>
                          )}
                        </Box>
                      </Grid>
                      <div style={{ height: '15px' }} />
                      <Grid container spacing={3}>
                        <Grid item md={6} xs={12}>
                          <Typography
                            variant="subtitle1"
                            sx={{
                              mb: 1,
                              fontWeight: 600,
                              color: '#333',
                              fontFamily: 'Jost, sans-serif',
                            }}
                          >
                            First Name
                          </Typography>
                          <TextField
                            fullWidth
                            placeholder="Enter your name"
                            name="firstName"
                            required
                            onChange={handleChange('firstName')}
                            onBlur={handleBlur('firstName')}
                            sx={{
                              fontFamily: 'Jost, sans-serif',
                              '& .MuiOutlinedInput-root': {
                                borderRadius: '12px',
                                fontFamily: 'Jost, sans-serif',
                                '& fieldset': {
                                  borderColor: '#e0e0e0',
                                  borderWidth: '1px',
                                },
                                '&:hover fieldset': {
                                  borderColor: '#d0d0d0',
                                },
                                '&.Mui-focused fieldset': {
                                  borderColor:
                                    environment.mainColor || '#FF6B35',
                                  borderWidth: '2px',
                                },
                              },
                              '& .MuiInputBase-input': {
                                padding: '14px 16px',
                                fontFamily: 'Jost, sans-serif',
                              },
                              '& .MuiInputBase-input::placeholder': {
                                fontFamily: 'Jost, sans-serif',
                              },
                            }}
                            value={values.firstName}
                            error={errors.firstName && touched.firstName}
                            variant="outlined"
                          />
                          {errors.firstName && touched.firstName ? (
                            <span
                              style={{
                                marginTop: '8px',
                                color: 'red',
                                fontSize: '12px',
                                display: 'block',
                              }}
                            >
                              {errors.firstName}
                            </span>
                          ) : null}
                        </Grid>

                        <Grid item md={6} xs={12}>
                          <Typography
                            variant="subtitle1"
                            sx={{
                              mb: 1,
                              fontWeight: 600,
                              color: '#333',
                              fontFamily: 'Jost, sans-serif',
                            }}
                          >
                            Last Name
                          </Typography>
                          <TextField
                            fullWidth
                            placeholder="Enter your name"
                            name="lastName"
                            required
                            onChange={handleChange('lastName')}
                            onBlur={handleBlur('lastName')}
                            sx={{
                              fontFamily: 'Jost, sans-serif',
                              '& .MuiOutlinedInput-root': {
                                borderRadius: '12px',
                                fontFamily: 'Jost, sans-serif',
                                '& fieldset': {
                                  borderColor: '#e0e0e0',
                                  borderWidth: '1px',
                                },
                                '&:hover fieldset': {
                                  borderColor: '#d0d0d0',
                                },
                                '&.Mui-focused fieldset': {
                                  borderColor: environment.mainColor,
                                  borderWidth: '2px',
                                },
                              },
                              '& .MuiInputBase-input': {
                                padding: '14px 16px',
                                fontFamily: 'Jost, sans-serif',
                              },
                              '& .MuiInputBase-input::placeholder': {
                                fontFamily: 'Jost, sans-serif',
                              },
                            }}
                            value={values.lastName}
                            error={errors.lastName && touched.lastName}
                            variant="outlined"
                          />
                          {errors.lastName && touched.lastName ? (
                            <span
                              style={{
                                marginTop: '8px',
                                color: 'red',
                                fontSize: '12px',
                                display: 'block',
                              }}
                            >
                              {errors.lastName}
                            </span>
                          ) : null}
                        </Grid>

                        <Grid item md={6} xs={12}>
                          <Typography
                            variant="subtitle1"
                            sx={{
                              mb: 1,
                              fontWeight: 600,
                              color: '#333',
                              fontFamily: 'Jost, sans-serif',
                            }}
                          >
                            Phone
                          </Typography>
                          <Box
                            sx={{ position: 'relative', width: '100%' }}
                            aria-required={true}
                          >
                            <PhoneInternational
                              phoneNumber={phoneNumber}
                              setPhoneNumber={setPhoneNumber}
                              backgroundColor="white"
                              onBlur={() => {
                                if (typeof setFieldValue === 'function') {
                                  setFieldValue(
                                    'phoneNumber',
                                    phoneNumber || ''
                                  );
                                }
                                if (
                                  typeof formikRef?.setFieldTouched ===
                                  'function'
                                ) {
                                  formikRef.setFieldTouched(
                                    'phoneNumber',
                                    true
                                  );
                                }
                              }}
                              borderRadius="12px"
                            />
                            {touched.phoneNumber && errors.phoneNumber && (
                              <span
                                style={{
                                  marginTop: '8px',
                                  color: 'red',
                                  fontSize: '12px',
                                  display: 'block',
                                }}
                              >
                                {errors.phoneNumber}
                              </span>
                            )}
                          </Box>
                        </Grid>

                        <Grid item md={6} xs={12}>
                          <Typography
                            variant="subtitle1"
                            sx={{
                              mb: 1,
                              fontWeight: 600,
                              color: '#333',
                              fontFamily: 'Jost, sans-serif',
                            }}
                          >
                            Email
                          </Typography>
                          <TextField
                            fullWidth
                            placeholder="Your email address"
                            name="email"
                            type="email"
                            required
                            onChange={handleChange('email')}
                            onBlur={handleBlur('email')}
                            sx={{
                              fontFamily: 'Jost, sans-serif',
                              '& .MuiOutlinedInput-root': {
                                borderRadius: '12px',
                                fontFamily: 'Jost, sans-serif',
                                '& fieldset': {
                                  borderColor: '#e0e0e0',
                                  borderWidth: '1px',
                                },
                                '&:hover fieldset': {
                                  borderColor: '#d0d0d0',
                                },
                                '&.Mui-focused fieldset': {
                                  borderColor:
                                    environment.mainColor || '#FF6B35',
                                  borderWidth: '2px',
                                },
                              },
                              '& .MuiInputBase-input': {
                                padding: '14px 16px',
                                fontFamily: 'Jost, sans-serif',
                              },
                              '& .MuiInputBase-input::placeholder': {
                                fontFamily: 'Jost, sans-serif',
                              },
                            }}
                            value={values.email}
                            error={errors.email && touched.email}
                            variant="outlined"
                          />
                          {errors.email && touched.email ? (
                            <span
                              style={{
                                marginTop: '8px',
                                color: 'red',
                                fontSize: '12px',
                                display: 'block',
                              }}
                            >
                              {errors.email}
                            </span>
                          ) : null}
                          {emailErr?.length > 0 && (
                            <span
                              style={{
                                marginTop: '8px',
                                color: 'red',
                                fontSize: '12px',
                                display: 'block',
                              }}
                            >
                              {emailErr}
                            </span>
                          )}
                        </Grid>

                        <Grid item xs={12}>
                          <Typography
                            variant="subtitle1"
                            sx={{
                              mb: 1,
                              fontWeight: 600,
                              color: '#333',
                              fontFamily: 'Jost, sans-serif',
                            }}
                          >
                            Message
                          </Typography>
                          <TextField
                            fullWidth
                            placeholder="Your message"
                            name="message"
                            multiline
                            required
                            rows={6}
                            onChange={handleChange('message')}
                            onBlur={handleBlur('message')}
                            sx={{
                              fontFamily: 'Jost, sans-serif',
                              '& .MuiOutlinedInput-root': {
                                borderRadius: '12px',
                                fontFamily: 'Jost, sans-serif',
                                '& fieldset': {
                                  borderColor: '#e0e0e0',
                                  borderWidth: '1px',
                                },
                                '&:hover fieldset': {
                                  borderColor: '#d0d0d0',
                                },
                                '&.Mui-focused fieldset': {
                                  borderColor:
                                    environment.mainColor || '#FF6B35',
                                  borderWidth: '2px',
                                },
                              },
                              '& .MuiInputBase-input': {
                                padding: '14px 16px',
                                fontFamily: 'Jost, sans-serif',
                              },
                              '& .MuiInputBase-input::placeholder': {
                                fontFamily: 'Jost, sans-serif',
                              },
                            }}
                            value={values.message}
                            error={errors.message && touched.message}
                            variant="outlined"
                          />
                          {errors.message && touched.message ? (
                            <span
                              style={{
                                marginTop: '8px',
                                color: 'red',
                                fontSize: '12px',
                                display: 'block',
                              }}
                            >
                              {errors.message}
                            </span>
                          ) : null}
                        </Grid>
                      </Grid>

                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'flex-start',
                          mt: 3,
                        }}
                      >
                        <Button
                          sx={{
                            backgroundColor: environment.mainColor,
                            color: 'white',
                            borderRadius: '25px',
                            padding: '12px 32px',
                            fontSize: '16px',
                            fontWeight: 600,
                            textTransform: 'none',
                            boxShadow: 'none',
                            minWidth: '120px',
                            '&:hover': {
                              backgroundColor: environment.mainColor,
                              opacity: 0.9,
                              boxShadow: 'none',
                            },
                            '&:disabled': {
                              backgroundColor: loading
                                ? environment.mainColor
                                : '#cccccc',
                              color: 'white',
                            },
                          }}
                          variant="contained"
                          type="submit"
                          onClick={() => {
                            // make sure Formik has the latest phone before validating/submitting
                            try {
                              setFieldValue &&
                                setFieldValue('phoneNumber', phoneNumber);
                            } catch (e) {
                              if (formikRef && formikRef.setFieldValue) {
                                formikRef.setFieldValue(
                                  'phoneNumber',
                                  phoneNumber
                                );
                              }
                            }
                            handleSubmit();
                          }}
                          disabled={
                            loading ||
                            !pattern.test(values.email) ||
                            !phoneNumber ||
                            Boolean(errors.phoneNumber)
                          }
                        >
                          {loading ? (
                            <>
                              <CircularProgress
                                size={20}
                                sx={{ color: 'white', mr: 1 }}
                              />
                              Sending...
                            </>
                          ) : (
                            'Send'
                          )}
                        </Button>
                      </Box>
                      <div style={{ height: '30px' }} />
                    </div>
                  );
                }}
              </Formik>
            </Container>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                width: '100%',
                height: { xs: '300px', md: '100%' },
                background: '#f7f7f7',
                borderRadius: '12px',
                minHeight: { xs: '300px', md: '500px' },
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mt: { xs: 3, md: 0 },
              }}
            >
              {nearestStore &&
              nearestStore.address.lat &&
              nearestStore.address.lng ? (
                <iframe
                  title="Google Map"
                  width="100%"
                  height="100%"
                  style={{ border: 0, borderRadius: '12px', minHeight: 300 }}
                  loading="lazy"
                  allowFullScreen
                  referrerPolicy="no-referrer-when-downgrade"
                  src={`https://www.google.com/maps?q=${nearestStore.address.lat},${nearestStore.address.lng}&z=16&output=embed&markers=color:red%7C${nearestStore.address.latitude},${nearestStore.address.longitude}`}
                ></iframe>
              ) : (
                <Typography variant="body2" color="textSecondary">
                  Map loading...
                </Typography>
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
export default Contactus;
